
import React from 'react';
import { Link } from 'react-router-dom';
import { Map, ExternalLink, LogIn, LayoutDashboard, Users, User, CalendarDays, Settings, FileBarChart, Calculator } from 'lucide-react';

interface SitemapProps { isPreview: boolean; }

const Sitemap: React.FC<SitemapProps> = ({ isPreview }) => {
  return (
    <div className="min-h-screen bg-slate-100 dark:bg-slate-800 p-8 flex flex-col items-center pt-24 font-sans text-sm">
      <div className="max-w-2xl w-full bg-white dark:bg-slate-900 border border-slate-300 dark:border-slate-700 p-8 shadow-sm rounded-sm">
        <header className="mb-8 border-b border-slate-200 dark:border-slate-800 pb-6">
          <div className="flex items-center gap-3 mb-2">
            <Map className="w-8 h-8 text-brand-700" />
            <h1 className="text-2xl font-bold text-slate-800 dark:text-slate-200 uppercase">Mapa do Site</h1>
          </div>
          <p className="text-slate-500 text-xs">
            Estrutura de Rotas (Modo Seguro: HashRouter)
          </p>
        </header>

        <div className="grid gap-4">
          <Link to="/login" className="flex items-center justify-between p-4 border border-slate-200 hover:bg-slate-50 dark:bg-slate-950 hover:border-brand-500 transition-colors group">
              <div className="flex items-center gap-4">
                <div className="p-2 bg-brand-100 text-brand-700 rounded"><LogIn className="w-5 h-5" /></div>
                <div><h3 className="font-bold text-slate-700 dark:text-slate-300 group-hover:text-brand-700">Login (Acesso)</h3><p className="text-xs text-slate-500">#/login</p></div>
              </div>
              <ExternalLink className="w-4 h-4 text-slate-400" />
          </Link>

          <Link to="/dashboard" className="flex items-center justify-between p-4 border border-slate-200 hover:bg-slate-50 hover:border-brand-500 transition-colors group">
              <div className="flex items-center gap-4">
                <div className="p-2 bg-brand-100 text-brand-700 rounded"><LayoutDashboard className="w-5 h-5" /></div>
                <div><h3 className="font-bold text-slate-700 group-hover:text-brand-700">Dashboard Financeiro</h3><p className="text-xs text-slate-500">#/dashboard</p></div>
              </div>
              <ExternalLink className="w-4 h-4 text-slate-400" />
          </Link>

          <Link to="/agenda" className="flex items-center justify-between p-4 border border-slate-200 hover:bg-slate-50 hover:border-brand-500 transition-colors group">
              <div className="flex items-center gap-4">
                <div className="p-2 bg-brand-100 text-brand-700 rounded"><CalendarDays className="w-5 h-5" /></div>
                <div><h3 className="font-bold text-slate-700 group-hover:text-brand-700">Agenda</h3><p className="text-xs text-slate-500">#/agenda</p></div>
              </div>
              <ExternalLink className="w-4 h-4 text-slate-400" />
          </Link>

          <Link to="/billing" className="flex items-center justify-between p-4 border border-slate-200 hover:bg-slate-50 hover:border-brand-500 transition-colors group">
              <div className="flex items-center gap-4">
                <div className="p-2 bg-brand-100 text-brand-700 rounded"><Calculator className="w-5 h-5" /></div>
                <div><h3 className="font-bold text-slate-700 group-hover:text-brand-700">Orçamentos / Faturamento</h3><p className="text-xs text-slate-500">#/billing</p></div>
              </div>
              <ExternalLink className="w-4 h-4 text-slate-400" />
          </Link>

          <Link to="/reports" className="flex items-center justify-between p-4 border border-slate-200 hover:bg-slate-50 hover:border-brand-500 transition-colors group">
              <div className="flex items-center gap-4">
                <div className="p-2 bg-brand-100 text-brand-700 rounded"><FileBarChart className="w-5 h-5" /></div>
                <div><h3 className="font-bold text-slate-700 group-hover:text-brand-700">Relatórios</h3><p className="text-xs text-slate-500">#/reports</p></div>
              </div>
              <ExternalLink className="w-4 h-4 text-slate-400" />
          </Link>
          
           <Link to="/users" className="flex items-center justify-between p-4 border border-slate-200 hover:bg-slate-50 hover:border-brand-500 transition-colors group">
              <div className="flex items-center gap-4">
                <div className="p-2 bg-brand-100 text-brand-700 rounded"><Users className="w-5 h-5" /></div>
                <div><h3 className="font-bold text-slate-700 group-hover:text-brand-700">Usuários</h3><p className="text-xs text-slate-500">#/users</p></div>
              </div>
              <ExternalLink className="w-4 h-4 text-slate-400" />
          </Link>

          <Link to="/profile" className="flex items-center justify-between p-4 border border-slate-200 hover:bg-slate-50 hover:border-brand-500 transition-colors group">
              <div className="flex items-center gap-4">
                <div className="p-2 bg-brand-100 text-brand-700 rounded"><User className="w-5 h-5" /></div>
                <div><h3 className="font-bold text-slate-700 group-hover:text-brand-700">Meu Perfil</h3><p className="text-xs text-slate-500">#/profile</p></div>
              </div>
              <ExternalLink className="w-4 h-4 text-slate-400" />
          </Link>

          <Link to="/settings" className="flex items-center justify-between p-4 border border-slate-200 hover:bg-slate-50 hover:border-brand-500 transition-colors group">
              <div className="flex items-center gap-4">
                <div className="p-2 bg-brand-100 text-brand-700 rounded"><Settings className="w-5 h-5" /></div>
                <div><h3 className="font-bold text-slate-700 group-hover:text-brand-700">Configurações</h3><p className="text-xs text-slate-500">#/settings</p></div>
              </div>
              <ExternalLink className="w-4 h-4 text-slate-400" />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Sitemap;
